import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { fetchWP } from "../../api/wp";
import Seo from "../../components/Seo";
import ContactBand from "../ContactBand";
import { POST_THUMB_OVERRIDES } from "../data/news";
import { formatDate } from "../news/useNewsItems";
import NotFoundPage from "./NotFoundPage";

const strip = (html = "") =>
  html
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .trim();

export default function NewsDetailPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(undefined); // undefined=読込中 / null=見つからない

  useEffect(() => {
    let alive = true;
    setPost(undefined);
    fetchWP("/wp/v2/posts", { slug, _embed: "" })
      .then((list) => alive && setPost(list?.[0] || null))
      .catch(() => alive && setPost(null));
    return () => {
      alive = false;
    };
  }, [slug]);

  if (post === null) return <NotFoundPage />;

  const title = post ? strip(post.title.rendered) : "";
  const image =
    post?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
    POST_THUMB_OVERRIDES.find((o) => title.includes(o.match))?.thumb;

  return (
    <main>
      {post && (
        <Seo
          title={title}
          description={strip(post.excerpt?.rendered).slice(0, 120)}
          path={`/news/${encodeURIComponent(slug).toLowerCase()}`}
          image={image}
          type="article"
        />
      )}
      <section className="page-hero ground" data-en="NEWS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/news">お知らせ</Link>
            <span>{title}</span>
          </nav>
          <div className="nd-meta">
            <time dateTime={post?.date?.slice(0, 10)}>
              {formatDate(post?.date?.slice(0, 10))}
            </time>
            <span className="nd-tag">お知らせ</span>
          </div>
          <h1 className="nd-title">{title}</h1>
        </div>
      </section>
      <section className="section nd-sec">
        <div className="container">
          <article className="nd-body">
            {image && (
              <figure className="nd-fig">
                <img src={image} alt="" />
              </figure>
            )}
            {post && (
              <div
                dangerouslySetInnerHTML={{ __html: post.content.rendered }}
              />
            )}
          </article>
          <div className="nd-back">
            <Link className="btn btn-sub" to="/news">
              お知らせ一覧へ戻る
            </Link>
          </div>
        </div>
      </section>
      <ContactBand />
    </main>
  );
}
